import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { ConversationUploadedImagesResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ConversationUploadedImagesResponseDataSchema>>

type Params = {
  conversationId: string
  files: File[]
}

export function useUploadConversationMessageImagesMutation() {
  return useMutation({
    mutationFn: async ({ conversationId, files }: Params) => {
      const formData = new FormData()

      for (const file of files) {
        formData.append("file", file)
      }

      const { data } = await axios.post<Response>(
        `/conversations/${conversationId}/messages/images`,
        formData,
      )

      return data.data
    },
  })
}
